import type { Components, Theme } from "@mui/material/styles";

export const MuiButton: Components<Theme>["MuiButton"] = {
  defaultProps: {
    color: "primary",
    size: "large",
    disableElevation: true,
    loadingPosition: "start",
    variant: "contained",
  },

  styleOverrides: {
    root: ({ theme }) => ({
      // add border to all buttons so sizing does not change
      border: `1px solid`,
      borderRadius: theme.shape.borderRadius,
      fontWeight: 500,
      letterSpacing: "0.5px",
      lineHeight: 1.375,
      whiteSpace: "nowrap",
      textTransform: "none",
    }),
    contained: {
      borderColor: "transparent",
    },
    text: {
      borderColor: "transparent",
    },
    sizeLarge: ({ theme }) => ({
      height: theme.spacing(5),
      padding: theme.spacing(1.125, 2),
      fontSize: "16px",
    }),
    sizeMedium: ({ theme }) => ({
      height: theme.spacing(4),
      padding: theme.spacing(0, 1.5),
      fontSize: "14px",
    }),
    sizeSmall: ({ theme }) => ({
      height: theme.spacing(3),
      padding: theme.spacing(0, 1),
      fontSize: "13px",
    }),
    loadingIndicator: ({ theme }) => ({
      variants: [
        {
          props: {
            loadingPosition: "start",
          },
          style: {
            left: theme.spacing(2.75),
            ".MuiButton-sizeSmall &": {
              left: theme.spacing(1.5),
            },
          },
        },
      ],
    }),
  },
};
